module.exports = "https://web-assets-production.autolist.com/_next/static/images/car-value-demo_en-79ae21ee96b92bec5273aba10bc03817.png";